import React from 'react'
import { Button, Grid, Typography, Link} from '@mui/material';
import colors from '../../colors'
import OTPInput from "otp-input-react";
import { useSelector, useDispatch } from 'react-redux';
import {selectRegistrationState, setIsForeignNumber, setIsOtpSuccessfullyResent} from '../../../features/registration/registrationSlice'
import {sendGeneralRequest} from '../../../features/generalRequest'
import { setGeneralMessage } from '../../../features/global/globalDataSlice';
import { useFormik } from 'formik'
import * as yup from 'yup'
import { makeStyles } from '@mui/styles';
import { texts } from '../../general/texts';
import Timer from '../../general/Timer';

const validationSchema = yup.object({
    otp: yup
      .string()
      .length(4)
      .required()
  });    
  
const SecondRegistrationStep = () => 
{
    const registrationSliceState = useSelector(selectRegistrationState) 
    const [shouldDisplayResendOtp, setShouldDisplayResendOtp] = React.useState(false)
    const dispatch = useDispatch()
    
    const formik = useFormik({
        initialValues: {
            otp: '',
            token: registrationSliceState.token,
            phone: registrationSliceState.phone,
            prefix: registrationSliceState.prefix
        },
        validationSchema: validationSchema,
        onSubmit: values => {
            dispatch(sendGeneralRequest({request: {_request: values},baseUrlKey:'auth', endpoint: 'ValidateOtp'}))
        }
    })

    const handleOtpChange = (otp) => 
    {
        formik.setFieldValue('otp', otp)
    }

    const resendOtp = () => 
    {
        dispatch(sendGeneralRequest({request: {token: registrationSliceState.token, phone: registrationSliceState.phone, prefix: registrationSliceState.prefix}, baseUrlKey:'auth', endpoint: 'ValidatePhone'}))
    }

    // React.useEffect(()=>{
    //     {registrationSliceState.prefix !== '355' && dispatch(setIsForeignNumber(true))}
    //     {registrationSliceState.isForeignNumber && formik.setFieldValue('otp', registrationSliceState.otp)}
    // }, [registrationSliceState.isForeignNumber, registrationSliceState.otp])

    React.useEffect(()=>{
        registrationSliceState.prefix !== '355' && formik.setFieldValue('otp', registrationSliceState.otp)   
    }, [registrationSliceState.otp])

    React.useEffect(()=>{
        if(registrationSliceState.isOtpSuccessfullyResent)
        {
            dispatch(setGeneralMessage({type: 'success', message: texts["message-otp-resend-success"]}))
            dispatch(setIsOtpSuccessfullyResent(false))
            setShouldDisplayResendOtp(false)
        }
    },[registrationSliceState.isOtpSuccessfullyResent])

    const useStyles = makeStyles({
        mianGrid:{
            width:'25%',
            '@media (max-width: 899px )' : {width:'50%'}
        },
        header:{
            color: colors.orange,
            fontFamily:'GerberaLight',
            fontSize:'1.5rem'
        },
        caption:{
            color: colors.gray,
            fontFamily:'GerberaLight'
        },
        link:{
            fontWeight:'bold',
            color: colors.darkBlue,
            fontFamily:'GerberaLight'
        },
        button:{
            background:colors.gradientOrange,
            color:colors.white,
            width:'12%',
            fontFamily:'GerberaBold',
            textTransform:'none',
            fontSize:'1rem',
            '@media (max-width: 899px)':{width:'40%'}
        }
    })

    const classes = useStyles()
    
    return(
        <form onSubmit={formik.handleSubmit}>        
            <Grid container justifyContent='center' width={'100%'}>
                <Grid container item className={classes.mainGrid}>
                    <Grid container item md={12} xs={12} mb={12} justifyContent='center'>
                        <Typography className={classes.header} >{texts["prompt-phone-verification"]}</Typography>
                    </Grid>
                    <Grid container item md={12} xs={12} justifyContent={'center'} mb={10}>
                        <OTPInput  inputStyles={{borderTop:'none', width:'80px' ,borderLeft:'none', outline:'none', borderRight:'none', fontFamily:'GerberaLight', borderBottomColor:colors.orange, color:colors.darkBlue, fontSize:'2rem', paddingBottom:'3%', height:'68%' }} value={formik.values.otp} onChange={handleOtpChange} autoFocus OTPLength={4} otpType="number" disabled={false} />
                    </Grid>
                    <Grid item md={12} xs={12} justifyContent='center'>
                        <Typography className={classes.caption} variant="caption">{texts["message-subtitle-phone-verification"]}</Typography>
                    </Grid>
                    <Grid item md={12} xs={12} justifyContent='center'>
                        {shouldDisplayResendOtp
                        ? <Link className={classes.link} onClick={resendOtp} type="button" component="button" underline="none" variant="overline">{texts["message-resend-otp"]}</Link>
                        :<Grid container item md={12} xs={12} justifyContent={'center'} mt={2}>
                                <Typography sx={{fontFamily:'GerberaBold', color: colors.darkBlue, marginRight:1}}>{texts["message-resend-otp-timer"]}</Typography>
                                <Timer duration={2 * 60 * 1000} onTimerCompleted={(value) => setShouldDisplayResendOtp(value)}/>
                            </Grid>
                        }
                        
                    </Grid>   
                </Grid>
                <Grid container item md={12} xs={12}  pt={3} justifyContent='center'>
                    <Button disabled={registrationSliceState.isLoading ? true : false} type='submit' className={classes.button}>{texts["button-continue"]}</Button>
                </Grid>                                             
            </Grid>
        </form>
    );
}

export default SecondRegistrationStep